import {Component, Input, OnInit} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {ProductService} from '@app/shared/services/product/product.service';
import {LoaderService} from '@app/core/services/loader/loader.service';

@Component({
  selector: 'app-product-detail-review',
  templateUrl: './product-detail-review.component.html',
  styleUrls: ['./product-detail-review.component.css']
})
export class ProductDetailReviewComponent implements OnInit {
  @Input() productId: any;
  @Input() rateValue!: number;
  reviewList !: any[];
  pageIndex = 0;
  pageSize = 5; // No of items to load from server side i.e no of items to take
  length = 0; // Total items count

  constructor( private productService: ProductService, private loader: LoaderService) { }

  ngOnInit() {

    this.fn_GetAvgRating(this.productId);
    this.fn_GetReviewListing();
  }

  fn_GetAvgRating(productId: any) {
    this.productService.getAvgRating(productId).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        if (res.Data.ResponseData !== null && res.Data.ResponseData > 0) {
          this.rateValue = res.Data.ResponseData;
        } else {
          this.rateValue = 0;
        }
        this.loader.hide();
      } else if (res.StatusCode === 400) {
        this.loader.hide();
      } else {
        this.loader.hide();
      }
    }, (err: any) => {
      this.loader.hide();
    });
  }

  fn_GetReviewListing() {
    this.loader.show();
    this.reviewList = [];
    this.productService.getProductReviews(this.productId, this.pageIndex,
      this.pageSize).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.fn_AddLazyLoadedItems(res.Data.ResponseData.Data);
        this.length = res.Data.ResponseData.Count; // Total count of review regardless of any pagination
        this.loader.hide();
      } else if (res.StatusCode === 204) {
        this.loader.hide();
      }
    }, (err: any) => {
      this.loader.hide();
    });
  }

  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems(items: any) {
    if (items !== null && items.length !== 0) {
      for (let i = 0; i < items.length; i++) {
        // check if item with same id exists
        if (!this.reviewList.find(x => x.ReviewId === items[i].ReviewId)) {
          this.reviewList.push(items[i]);
        }
      }
    }
  }

  /** Func called on pagination event from html to get reviews listing */
  fn_GetReviewsData(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fn_GetReviewListing();
  }

}
